import Container from '@/components/Container';
import Tooltip from '@/components/Tooltip';
import MarketingSection from './MarketingSection';

export default function MarketingContact() {
  return (
    <MarketingSection className="bg-gray-900 text-white" sectionTitle="¿Necesitas ayuda o tienes alguna duda?">
      <Container maxWidth="max-w-screen-lg" className="text-center space-y-4 lg:space-y-6 -mt-10 lg:-mt-16">
        <h4 className="text-lg lg:text-xl text-gray-400 font-normal">
          Contacta con nosotros y estaremos encantados de ayudarte con cualquier duda o
          requerimiento que tengas. Puedes hacerlo a través de nuestro chat o escribirnos
          al correo electrónico.
        </h4>
        <h5 className="text-xl font-semibold">
          <Tooltip tooltip="Enviar correo electrónico">
            <a className="font-inherit inline-flex leading-tight bg-white rounded-full shadow hover:shadow-xl text-gray-900 px-6 py-3 transition ease-in-out duration-100" href="mailto:info@aibes.org">
              info@aibes.org
            </a>
          </Tooltip>
        </h5>
      </Container>
    </MarketingSection>
  );
}
